/* Fit page (cohort) personalization: ?ac=<airplane> from an ad narrows the answer and the button
   to that airplane, using the same Fit.classify() as every selector. Plus the sticky bar. */
(function () {
  "use strict";
  var root = document.querySelector("[data-rt-cohort]");
  if (!root) return;
  var DATA = JSON.parse(root.querySelector("[data-cohort-data]").textContent);
  var sticky = root.querySelector("[data-cohort-sticky]");
  var stickyFit = root.querySelector("[data-sticky-fit]");
  var stickyCta = root.querySelector("[data-sticky-cta]");
  var one = root.querySelector("[data-cohort-one]");
  var ac = new URLSearchParams(window.location.search).get("ac");

  function personalize(Fit) {
    if (!ac) return;
    var a = Fit.getAircraft(ac);
    if (!a) return;
    var c = Fit.classify(a);
    var member = DATA.members.indexOf(a.id) !== -1;
    var pants = a.follow_up && /pant/i.test(a.follow_up.q);
    Array.prototype.forEach.call(root.querySelectorAll('.rt-cohort-member[data-member="' + a.id + '"]'), function (el) { el.classList.add("is-yours"); });
    var verdict = root.querySelector("[data-cohort-verdict]");
    var answer = root.querySelector("[data-cohort-answer]");
    if ((c === "fits" || c === "confirm-proSF") && member) {
      verdict.textContent = c === "fits" ? "Fits your " + a.display + "." : "Fits your " + a.display + " with the " + (a.unit === "6700" ? "SF" : "Pro") + " frame, confirm with us.";
      one.textContent = "Build my " + a.display + " kit";
      one.href = DATA.kitPath + "?ac=" + encodeURIComponent(a.id);
      one.hidden = false;
      root.querySelector("[data-cohort-pick]").classList.add("is-secondary");
      root.querySelector(".rt-cohort-pick-label").textContent = "Or another airplane in this family:";
      stickyFit.textContent = "Fits your " + a.display + (pants ? " with the nose pant off." : ".");
      stickyCta.textContent = "Build my kit"; stickyCta.href = one.href;
    } else if (c === "confirm-unconfirmed") {
      answer.className = "rt-cohort-answer is-ask";
      verdict.textContent = "Confirm with us: " + a.display + ".";
      one.textContent = "Send photos of my nose gear";
      one.href = (Fit.config().contactPath || "/pages/contact") + "?airplane=" + encodeURIComponent(a.display) + "&ac=" + encodeURIComponent(a.id);
      one.hidden = false;
      stickyFit.textContent = "Confirm with us: " + a.display + ".";
      stickyCta.textContent = "Send photos"; stickyCta.href = one.href;
    } else if (c === "nofit") {
      answer.className = "rt-cohort-answer is-no";
      verdict.textContent = "Does not fit your " + a.display + ".";
      one.textContent = "See what does fit"; one.href = "/pages/airplanes-we-fit"; one.hidden = false;
      root.querySelector("[data-cohort-pick]").hidden = true;
      root.querySelector(".rt-cohort-pick-label").hidden = true;
      stickyFit.textContent = "Does not fit your " + a.display + ".";
      stickyCta.textContent = "See what does fit"; stickyCta.href = one.href;
    }
    root.querySelector("[data-cohort-answer] .rt-glyph").outerHTML = Fit.glyph(c === "nofit" ? "no" : c === "confirm-unconfirmed" ? "ask" : "yes");
    if (typeof window.rtTrackOnce === "function") {
      window.rtTrack("rt_aircraft_selected", { aircraft_id: a.id, aircraft_make: Fit.makeOf(a), match_type: "url_param", entry_point: "cohort_" + (location.pathname.split("/").pop() || ""), follow_up_required: !!a.follow_up });
    }
  }

  var target = root.querySelector("[data-cohort-cta]"), ticking = false;
  function check() {
    ticking = false;
    var show = target.getBoundingClientRect().bottom < 0;
    if (sticky.hidden === !show) return;
    sticky.hidden = !show;
    document.documentElement.style.scrollPaddingBottom = show ? sticky.offsetHeight + 12 + "px" : "";
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
  window.addEventListener("scroll", onScroll, { passive: true });
  document.addEventListener("scroll", onScroll, { passive: true, capture: true });

  if (window.RobotowFit) window.RobotowFit.ready(function () { personalize(window.RobotowFit); });
})();
